// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__ASv5_","benefit-item":"style_benefit-item__8mvUO"};